<!--
  L'enveloppe de tous les tableaux du module.

  POURQUOI
  Les six vues n'avaient AUCUN état de chargement et AUCUN état d'erreur :
  quatre appels axios sur neuf n'avaient même pas de `.catch()`, et le détail
  d'une parcelle affichait une page blanche pendant le chargement. Un écran qui
  affiche zéro parce qu'il n'a pas fini de charger ment, et un écran qui affiche
  zéro parce que la requête a échoué ment davantage.

  Les quatre états sont ici, une fois, avec un `key` explicite sur chaque branche
  — Vuesax déplace ses popups dans document.body, et un diff sans clé entre
  branches voisines peut détruire une popup montée et figer la page (leçon
  documentée dans QuotationBacklogAnalysis.vue).
-->
<template>
  <div>
    <div v-if="loading" key="hv-l" class="hv2-loading">
      <vs-progress indeterminate color="primary" class="mb-2" />
      Chargement…
    </div>

    <div v-else-if="error" key="hv-e" class="hv2-error">
      <b>Impossible d'afficher ces données.</b><br />
      {{ error }}
    </div>

    <hv-empty
      v-else-if="!rows.length"
      key="hv-0"
      :icon="emptyIcon"
      :title="emptyTitle"
      :text="emptyText"
    >
      <slot name="empty-action" />
    </hv-empty>

    <vs-table v-else key="hv-t" :data="rows" v-bind="$attrs" class="table-dark-inverted">
      <template slot="thead"><slot name="thead" /></template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(r, i) in data" :key="keyOf(r, i)">
          <slot name="row" :r="r" :i="i" />
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import HvEmpty from './HvEmpty'

export default {
  name: 'HvTable',
  components: { HvEmpty },
  inheritAttrs: false,
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    rowKey: { type: String, default: 'apv_code' },
    emptyIcon: { type: String, default: 'CheckCircleIcon' },
    emptyTitle: { type: String, default: '' },
    emptyText: { type: String, default: 'Rien à afficher.' }
  },
  methods: {
    keyOf (r, i) {
      const k = r && r[this.rowKey]
      return k === undefined || k === null ? i : `${k}-${i}`
    }
  }
}
</script>
